module.exports = __webpack_public_path__ + "static/media/autobook-appt.4279846e.svg";